<template>
    <div :class="{help:!isMobile,mHelp:isMobile,mobileCommon:isMobile}">
        <header>
            <p class="SubTitle el-link" @click="$router.go(0)">{{langPage['v4-help']['TXT_titre']}}</p>
            <img class="left" src="@/assets/img/help/Cercle0.svg" alt/>
            <img class="center" src="@/assets/img/help/Cercle1.svg" alt/>
            <img class="right" src="@/assets/img/help/Cercle2.svg" alt/>
            <img class="Tro" src="@/assets/img/help/Troisgouttes.svg" alt/>
            <img class="arc" src="@/assets/img/help/Arc.svg" alt/>
            <img class="arc2" src="@/assets/img/help/Arc2.svg" alt/>
            <div class="search">
                <!-- <input type="text" placeholder=""> -->
                <el-input
                        :placeholder="langPage['pages-support']['TXT_recherchequestion']"
                        v-model="searchval"
                        @input="input"
                        class="searchInput"
                        v-on:keyup.native.enter="searchQuestion"
                >
                    <i
                            class="el-input__icon el-icon-search"
                            slot="suffix"
                            @click="searchQuestion"
                    ></i>

                </el-input>
                <!--                <div class="select" v-if="searchval.length">-->
                <!--                    <p class="title">Top suggestions</p>-->
                <!--                    <div v-for="(item,i ) in 4" :key="i">-->
                <!--                        <p>ssss</p>-->
                <!--                        <span>1111</span>-->
                <!--                    </div>-->
                <!--                    <div>-->
                <!--                        <p>ssss</p>-->
                <!--                        <span>1111</span>-->
                <!--                    </div>-->
                <!--                    <div>-->
                <!--                        <p>ssss</p>-->
                <!--                        <span>1111</span>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!-- <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="state"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                  @blur="blur"
                >
                  <i
                    class="el-input__icon"
                    :class="close?'el-icon-close':'el-icon-search'"
                    slot="suffix"
                    @click="handleIconClick"
                  ></i>

                  <template slot-scope="{ item }">
                    <div class="select">
                      <p>{{item.value}}</p>
                      <span>{{item.right}}</span>
                    </div>
                  </template>
                </el-autocomplete>-->
            </div>
        </header>
        <div v-if="list.length===0" style="margin-top: 3vw">{{langPage['catalogue-liste']['TXT_aucunresultat']}}</div>
        <div class="cont" v-if="flag">
            <div class="item" v-for="(question,i) in list" :key="i">
                <section class="icon">
                    <img v-if="question.id_support_case==6" :src="require('../assets/img/help/icon0.svg')" alt/>
                    <img v-if="question.id_support_case==1" :src="require('../assets/img/help/icon1.svg')" alt/>
                    <!--          <img v-if="question.id_support_case==6" :src="require('../../assets/img/help/icon2.svg')" alt />-->
                    <img v-if="question.id_support_case==60" :src="require('../assets/img/help/icon3.svg')" alt/>
                    <img v-if="question.id_support_case==37" :src="require('../assets/img/help/icon4.svg')" alt/>
                    <img v-if="question.id_support_case==13" :src="require('../assets/img/help/icon5.svg')" alt/>
                    <img v-if="question.id_support_case==19" :src="require('../assets/img/help/icon6.svg')" alt/>
                    <img v-if="question.id_support_case==26" :src="require('../assets/img/help/icon7.svg')" alt/>
                    <img v-if="question.id_support_case==30" :src="require('../assets/img/help/icon8.svg')" alt/>
                </section>
                <p>{{question.support_cases_langues[0].libelle}}</p>
                <span class="exQues" @click="toDetail(i,qIdx)"
                      v-for="qIdx in 3">{{question.ques.length>0 && question.ques[qIdx-1]?question.ques[qIdx-1].support_cases_langues[0].libelle:''}}</span>
                <div @click="toDetail(i)" class="all">
                    <p>{{langPage['menu-header']['TXT_voirtout']}}</p>
                    <img class="arrow" src="../assets/img/help/arrow.png" alt/>
                </div>
            </div>
            <div class="item seat"></div>
            <div class="item seat"></div>
            <div class="item seat"></div>
        </div>
        <div class="detail" v-else>
            <div class="quesType">
                <div :class="{type:true,act:tIdx == index}" @click="index = tIdx" v-for="(type,tIdx) in list">
                    {{type.support_cases_langues[0].libelle.toUpperCase()}}
                </div>
            </div>
            <div class="quesDetail">
                <el-collapse class="questionOption" v-model="qIndex" accordion>
                    <el-collapse-item v-for="(q,qi) in list[index].ques" :title="q.support_cases_langues[0].libelle"
                                      :name="qi">
                        <div class="content" v-html="q.support_cases_langues[0].texte"></div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>

</template>
<script>
    import bottomNav from "../components/bottomNav";

    export default {
        name: "help",
        components: {
            bottomNav
        },
        data() {
            return {
                isMobile: this.$store.state.isMobile,
                searchval: '',
                list: [],
                flag: true,
                index: 0,
                qIndex: 0,
                tempList: [],//搜索后显示的内容
                query: this.$route.query,
            };
        },
        methods: {
            input() {
            },
            searchQuestion() {
                if (!this.searchval) return this.list = {...this.tempList};
                this.list = [];
                let temp = Object.values(this.tempList);
                for (let question of temp) {
                    console.log('libelle', question.support_cases_langues[0].libelle);
                    //搜索的是标题的话就只显示标题的内容
                    if (question.support_cases_langues[0].libelle.toLowerCase().includes(this.searchval.toLowerCase())) {
                        this.list = []
                        this.list.push(question);
                        this.index=0;
                        break;
                    }
                    for (let quesDetail of question.ques) {
                        if (quesDetail.support_cases_langues[0].texte.toLowerCase().includes(this.searchval.toLowerCase()) && !this.list.includes(question)) {
                            this.list.push(question);
                        }
                    }
                }
                if (this.list.length > 0) this.flag = false;
            },
            toDetail(i, qidx) {
                this.index = i || 0
                this.qIndex = qidx || 0
                this.flag = false
                window.scrollTo(0,0)
            }
        },
        computed: {
            langPage() {
                return this.$store.state['langPage']
            }
        },
        mounted() {
            let that = this;
            this.$api.help.list({'id_langue': this.$store.state['lang']}).then(res => {
                let list = res.data
                list.forEach(item => {
                    item.ques = []
                    this.$api.help.list({
                        id_support_case_parent: item.id_support_case,
                        id_langue: this.$store.state['lang']
                    }).then(response => {
                        item.ques = response.data
                    })
                })
                that.tempList = {...list};
                that.list = {...list};

                if (that.query.questionIndex) {
                    that.index = that.query.questionIndex;
                    that.flag = false;
                }
            })
            .then(res => {
                if(that.$route.query.keyword) {
                    for(let id in that.list) {
                        if(that.list[id].support_cases_langues[0].libelle.toLowerCase().includes(that.$route.query.keyword.toLowerCase())) {
                            that.toDetail(id, undefined)
                            break
                        }
                    }
                }
            })
        }
    };
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Help.less">
</style>
